import{Edit, SimpleForm,TextInput, DateInput} from 'react-admin';

const UserEdit = () =>(
    <Edit title="Editar Usuario" >
        <SimpleForm>
            <TextInput source='id' disabled />
            <TextInput source='firstName' label='Nombre'/>
            <TextInput source='lastName ' label='Apellido'/>
            <TextInput source='emaill' label='Email'/>
            <TextInput source='phone' label='Celular'/>
            <TextInput source='birthDate' label='Fecha de Nacimiento'/>
                        
        </SimpleForm>

    </Edit>
);


export default UserEdit;